import { COLOR_CONSTANTS } from './index'

export const colors = {
  primary: COLOR_CONSTANTS.COBALT,
  primaryText: COLOR_CONSTANTS.NAVY,
  secondaryText: COLOR_CONSTANTS.SAPPHIRE,
  ternaryText: COLOR_CONSTANTS.VENUS_MIST,
  denimText: COLOR_CONSTANTS.DENIM,
  white: COLOR_CONSTANTS.WHITE,
  primary_text_reverted: COLOR_CONSTANTS.WHITE,
  error: COLOR_CONSTANTS.FLUORESCENT_RED,
  warning: COLOR_CONSTANTS.PUMPKIN_PIE,
  success: COLOR_CONSTANTS.JUNGLE_GREEN,
  info: COLOR_CONSTANTS.CERULEAN,
  background: COLOR_CONSTANTS.DAISY,
  background_card: COLOR_CONSTANTS.WHITE,
  background_card_secondary: COLOR_CONSTANTS.WHITE,
  background_modal_overlay: COLOR_CONSTANTS.SALUTE,
  background_modal_header: COLOR_CONSTANTS.BOYSENBERRY_SHADOW,
  background_modal: COLOR_CONSTANTS.WHITE,
  background_item_hover: COLOR_CONSTANTS.ZHEN_ZHU_BAI_PEARL,

  cliploader_color: COLOR_CONSTANTS.COBALT,

  border_color: COLOR_CONSTANTS.SOLITUDE,
  border_color_hover: COLOR_CONSTANTS.NAVY,
  border_color_light: COLOR_CONSTANTS.SALT,
  border_color_light_hover: COLOR_CONSTANTS.CERULEAN,

  background_badge_active: COLOR_CONSTANTS.JUNGLE_GREEN,
  background_badge_default: COLOR_CONSTANTS.ROCKMAN_BLUE,
  background_badge_inactive: COLOR_CONSTANTS.COSMIC_ENERGY,
  background_badge_warning: COLOR_CONSTANTS.PUMPKIN_PIE,

  background_slider: COLOR_CONSTANTS.DAISY,
  background_item_light: COLOR_CONSTANTS.ZHEN_ZHU_BAI_PEARL,
  background_post_preview: COLOR_CONSTANTS.ZHEN_ZHU_BAI_PEARL,

  input_placeholder_color: COLOR_CONSTANTS.COSMIC_ENERGY,
  icon_color_gray: COLOR_CONSTANTS.COSMIC_ENERGY,
  icon_background: COLOR_CONSTANTS.WHITE,
  icon_background_hover: COLOR_CONSTANTS.DAISY,

  box_shadow: COLOR_CONSTANTS.SALUTE,

  menu_background: COLOR_CONSTANTS.DENIM,

  background_loading_progress: COLOR_CONSTANTS.DAISY,

  progress_line_background: COLOR_CONSTANTS.SPRUCE,
  progress_line_color: COLOR_CONSTANTS.COBALT,

  composer_icons_color: COLOR_CONSTANTS.GLACIER_PEARL,
  composer_variable_color: COLOR_CONSTANTS.ROCKMAN_BLUE,
  composer_selected_text_range_color: COLOR_CONSTANTS.COSMIC_ENERGY,

  background_internal_textarea: COLOR_CONSTANTS.CARROT,

  text_slash_divider_color: COLOR_CONSTANTS.VIOLET_WHIMSEY,

  switch_component_background_on: COLOR_CONSTANTS.COBALT,
  switch_component_background_off: COLOR_CONSTANTS.COSMIC_ENERGY,

  primary_button_border: COLOR_CONSTANTS.ZHEN_ZHU_BAI_PEARL, // border of primary/gradient button
  primary_button_background: 'linear-gradient(90deg, #0b60da 0%, #2482fd 100%)', // background of primary/gradient button
  gray_button_background: COLOR_CONSTANTS.ZHEN_ZHU_BAI_PEARL, // background of gray button
  gray_button_color: COLOR_CONSTANTS.SALUTE, // text color inside of gray button

  dashboard_statistics_alerts_text_color: COLOR_CONSTANTS.CERULEAN, // info color on dashboard texts in the right section
  dashboard_error_color: COLOR_CONSTANTS.FLUORESCENT_RED,
  dashboard_info_color: COLOR_CONSTANTS.CERULEAN,

  checkbox_background: COLOR_CONSTANTS.WHITE,
  checkbox_color: COLOR_CONSTANTS.NAVY,

  inbox_default_background_message_color: COLOR_CONSTANTS.SALT,
  inbox_for_reply_background_message_color: COLOR_CONSTANTS.DAISY,
  inbox_internal_background_message_color: COLOR_CONSTANTS.CARROT,
  inbox_own_background_message_color: COLOR_CONSTANTS.COBALT,

  inbox_default_primary_text_message_color: COLOR_CONSTANTS.VENUS_MIST,
  inbox_default_secondary_text_message_color: COLOR_CONSTANTS.VENUS_MIST,
  inbox_for_reply_primary_text_message_color: COLOR_CONSTANTS.VENUS_MIST,
  inbox_for_reply_secondary_text_message_color: COLOR_CONSTANTS.VENUS_MIST,
  inbox_internal_primary_text_message_color: COLOR_CONSTANTS.VENUS_MIST,
  inbox_internal_secondary_text_message_color: COLOR_CONSTANTS.VENUS_MIST,
  inbox_own_primary_text_message_color: COLOR_CONSTANTS.WHITE,
  inbox_own_secondary_text_message_color: COLOR_CONSTANTS.WHITE,

  dropdown_component_background: COLOR_CONSTANTS.WHITE,
  dropdown_component_item_color: COLOR_CONSTANTS.NAVY,
  dropdown_component_item_hover_background: COLOR_CONSTANTS.SALT,
  dropdown_component_item_hover_color: COLOR_CONSTANTS.NAVY,

  organic_color: COLOR_CONSTANTS.JUNGLE_GREEN,
  paid_color: COLOR_CONSTANTS.AKEBI_PURPLE, // COLOR_CONSTANTS.SAPPHIRE,

  report_ai_summary_background: COLOR_CONSTANTS.TERTIARY_PURPLE_50,
  report_ai_summary_text_color: COLOR_CONSTANTS.TERTIARY_PURPLE,
  report_ai_summary_header: COLOR_CONSTANTS.TERTIARY_PURPLE_200,
  report_ai_summary_header_highlight_color: COLOR_CONSTANTS.DAISY,
  report_ai_summary_base_color: COLOR_CONSTANTS.TERTIARY_PURPLE_100,

  inbox_ai_summary_background: COLOR_CONSTANTS.TERTIARY_PURPLE,
  inbox_ai_summary_text_color: COLOR_CONSTANTS.TERTIARY_PURPLE,
  inbox_ai_summary_base_color: COLOR_CONSTANTS.TERTIARY_PURPLE_100,
  inbox_ai_summary_highlight_color: COLOR_CONSTANTS.DAISY,
  inbox_ai_summary_border_color: COLOR_CONSTANTS.TERTIARY_PURPLE_200,
  inbox_ai_summary_background_color: COLOR_CONSTANTS.TERTIARY_PURPLE_50,

  dark_pill_background: COLOR_CONSTANTS.BLACK,
  referral_background_referral_link: COLOR_CONSTANTS.LIGHT_BLUE,
  referral_step_background: '#e9f1fd',
}
